<template>
  <section class="container m-auto h-full container flex justify-center items-center sm:h-full md:h-screen lg:h-screen xl:h-screen text-center pb-16 pt-16 sm:pb-32 md:pb-32 lg:pb-12 xl:pb-12">   
    <div class="w-5/6 sm:w-5/6 md:w-3/4 lg:w-3/4 xl:w-3/4">
      <div v-if="instruction.identifier === 'thankyou' || instruction.identifier === 'start2'">
        <svg class="inline justify-self-end bg-blue-200 text-blue-800 mb-8 p-4 border-2 border-blue-800 rounded-full" height="128" width="128" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
        </svg>
      </div>
      <div v-else-if="instruction.type === 'instruction' && instruction.linkId !== 'submit' && instruction.identifier !== 'start' && instruction.identifier !== 'start2'">
        <svg class="inline justify-self-end bg-blue-200 text-blue-800 mb-8 p-4 border-2 border-blue-800 rounded-full" height="128" width="128" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      </div>
      <div v-else class="text-3xl mb-8">
        {{instruction.title}}
      </div>
      <div class="mb-6 max-w-full text-2xl text-gray-800 leading-8">
        <span class="text-base text-blue-500 leading-7">{{instruction.prefix}}</span> 
        {{instruction.text}}
      </div>
      <div class="h-full w-auto flex justify-center">
        <div class="submit-wrapper" v-for="(action, index) in instruction.actions" :key="index">
          <div class="button-wrapper items-center">
            <button class="bg-blue-700 hover:bg-gray-200 text-white hover:text-green-600 border border-blue-700 hover:border-green-600 font-bold py-2 px-6 text-lg rounded-lg"
              @click="$emit('action', [ {action: action, orderNum: instruction.orderNum} ])">
                {{action.label}}
            </button>
          </div>
          <div class="keypress-wrapper" v-if="!isMobile()">
            <div class="keypress-label text-blue-700 font-bold">{{getCommandLocale(action.keystroke, $route.params.lang)}}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import translateMixin from '../mixins/translateMixin';

export default {
  mixins: [translateMixin],
  props: ['instruction'],
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      }
      return false
    }
  }
}
</script>